"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: underwriting/application.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Funderwriting%2Fapplication.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.employmentStatusToJSON = exports.employmentStatusFromJSON = exports.statusReasonToJSON = exports.statusReasonFromJSON = exports.applicationStatusToJSON = exports.applicationStatusFromJSON = exports.AnnualIncomeAmountRange = exports.AnnualIncome = exports.BorrowerInfo = exports.Application = exports.EmploymentStatus = exports.StatusReason = exports.ApplicationStatus = void 0;
const amount_1 = require("../common/amount");
const product_1 = require("./product");
const protobufPackage = 'com.step.underwriting.common.proto';
/**
 * Status of a credit line application
 */
var ApplicationStatus;
(function (ApplicationStatus) {
    ApplicationStatus["INVALID_APPLICATION_STATUS"] = "INVALID_APPLICATION_STATUS";
    /**
     * APPLIED - Application is in progress
     */
    ApplicationStatus["APPLIED"] = "APPLIED";
    /**
     * PENDING_DATA - Application is pending additional data
     */
    ApplicationStatus["PENDING_DATA"] = "PENDING_DATA";
    /**
     * APPROVED - Approved by us, user need to accept the offer
     */
    ApplicationStatus["APPROVED"] = "APPROVED";
    /**
     * DECLINED - Declined by us.
     */
    ApplicationStatus["DECLINED"] = "DECLINED";
    /**
     * WITHDRAWN - We withdrew the offer for some reason
     */
    ApplicationStatus["WITHDRAWN"] = "WITHDRAWN";
    ApplicationStatus["UNRECOGNIZED"] = "UNRECOGNIZED";
})(ApplicationStatus || (exports.ApplicationStatus = ApplicationStatus = {}));
/**
 * Reason for some of the statuses of a credit line application
 */
var StatusReason;
(function (StatusReason) {
    StatusReason["INVALID_STATUS_REASON"] = "INVALID_STATUS_REASON";
    StatusReason["WITHDRAWN_EXPIRED"] = "WITHDRAWN_EXPIRED";
    StatusReason["PENDING_CREDIT_UNFREEZE"] = "PENDING_CREDIT_UNFREEZE";
    StatusReason["HIGH_RISK_USER"] = "HIGH_RISK_USER";
    StatusReason["CREDIT_REPORT_DECEASED"] = "CREDIT_REPORT_DECEASED";
    StatusReason["FRAUD_ALERT"] = "FRAUD_ALERT";
    StatusReason["UNRECOGNIZED"] = "UNRECOGNIZED";
})(StatusReason || (exports.StatusReason = StatusReason = {}));
/**
 * Employment status of the applicant
 */
var EmploymentStatus;
(function (EmploymentStatus) {
    EmploymentStatus["INVALID_EMPLOYMENT_STATUS"] = "INVALID_EMPLOYMENT_STATUS";
    EmploymentStatus["UNEMPLOYED"] = "UNEMPLOYED";
    EmploymentStatus["EMPLOYED"] = "EMPLOYED";
    EmploymentStatus["RETIRED"] = "RETIRED";
    EmploymentStatus["STUDENT"] = "STUDENT";
    EmploymentStatus["SELF_EMPLOYED"] = "SELF_EMPLOYED";
    EmploymentStatus["UNRECOGNIZED"] = "UNRECOGNIZED";
})(EmploymentStatus || (exports.EmploymentStatus = EmploymentStatus = {}));
function createBaseApplication() {
    return {
        id: '',
        status: ApplicationStatus.INVALID_APPLICATION_STATUS,
        statusReason: StatusReason.INVALID_STATUS_REASON,
        employmentStatus: EmploymentStatus.INVALID_EMPLOYMENT_STATUS,
        annualIncome: undefined,
        info: undefined,
        products: [],
        createdAtMs: '0',
        updatedAtMs: '0',
        retryAfterMs: '0',
        closedAtMs: '0',
    };
}
exports.Application = {
    fromJSON(object) {
        const message = {
            id: isSet(object.id) ? globalThis.String(object.id) : '',
            status: isSet(object.status)
                ? applicationStatusFromJSON(object.status)
                : ApplicationStatus.INVALID_APPLICATION_STATUS,
            createdAtMs: isSet(object.createdAtMs) ? globalThis.String(object.createdAtMs) : '0',
            updatedAtMs: isSet(object.updatedAtMs) ? globalThis.String(object.updatedAtMs) : '0',
        };
        if (isSet(object.statusReason)) {
            message.statusReason = statusReasonFromJSON(object.statusReason);
        }
        if (isSet(object.employmentStatus)) {
            message.employmentStatus = employmentStatusFromJSON(object.employmentStatus);
        }
        if (isSet(object.annualIncome)) {
            message.annualIncome = exports.AnnualIncome.fromJSON(object.annualIncome);
        }
        if (isSet(object.info)) {
            message.info = exports.BorrowerInfo.fromJSON(object.info);
        }
        if (globalThis.Array.isArray(object?.products)) {
            message.products = object.products.map((e) => product_1.Product.fromJSON(e));
        }
        if (isSet(object.retryAfterMs)) {
            message.retryAfterMs = globalThis.String(object.retryAfterMs);
        }
        if (isSet(object.closedAtMs)) {
            message.closedAtMs = globalThis.String(object.closedAtMs);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== '') {
            obj.id = message.id;
        }
        if (message.status !== ApplicationStatus.INVALID_APPLICATION_STATUS) {
            obj.status = applicationStatusToJSON(message.status);
        }
        if (message.statusReason !== undefined &&
            message.statusReason !== StatusReason.INVALID_STATUS_REASON) {
            obj.statusReason = statusReasonToJSON(message.statusReason);
        }
        if (message.employmentStatus !== undefined &&
            message.employmentStatus !== EmploymentStatus.INVALID_EMPLOYMENT_STATUS) {
            obj.employmentStatus = employmentStatusToJSON(message.employmentStatus);
        }
        if (message.annualIncome !== undefined) {
            obj.annualIncome = exports.AnnualIncome.toJSON(message.annualIncome);
        }
        if (message.info !== undefined) {
            obj.info = exports.BorrowerInfo.toJSON(message.info);
        }
        if (message.products?.length) {
            obj.products = message.products.map((e) => product_1.Product.toJSON(e));
        }
        if (message.createdAtMs !== '0') {
            obj.createdAtMs = message.createdAtMs;
        }
        if (message.updatedAtMs !== '0') {
            obj.updatedAtMs = message.updatedAtMs;
        }
        if (message.retryAfterMs !== undefined && message.retryAfterMs !== '0') {
            obj.retryAfterMs = message.retryAfterMs;
        }
        if (message.closedAtMs !== undefined && message.closedAtMs !== '0') {
            obj.closedAtMs = message.closedAtMs;
        }
        return obj;
    },
    create(base) {
        return exports.Application.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseApplication();
        message.id = object.id ?? '';
        message.status = object.status ?? ApplicationStatus.INVALID_APPLICATION_STATUS;
        message.statusReason = object.statusReason ?? StatusReason.INVALID_STATUS_REASON;
        message.employmentStatus = object.employmentStatus ??
            EmploymentStatus.INVALID_EMPLOYMENT_STATUS;
        message.annualIncome = (object.annualIncome !== undefined && object.annualIncome !== null)
            ? exports.AnnualIncome.fromPartial(object.annualIncome)
            : undefined;
        message.info = (object.info !== undefined && object.info !== null)
            ? exports.BorrowerInfo.fromPartial(object.info)
            : undefined;
        message.products = object.products?.map((e) => product_1.Product.fromPartial(e)) || [];
        message.createdAtMs = object.createdAtMs ?? '0';
        message.updatedAtMs = object.updatedAtMs ?? '0';
        message.retryAfterMs = object.retryAfterMs ?? '0';
        message.closedAtMs = object.closedAtMs ?? '0';
        return message;
    },
};
function createBaseBorrowerInfo() {
    return { employmentStatus: EmploymentStatus.INVALID_EMPLOYMENT_STATUS, annualIncome: undefined };
}
exports.BorrowerInfo = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.employmentStatus)) {
            message.employmentStatus = employmentStatusFromJSON(object.employmentStatus);
        }
        if (isSet(object.annualIncome)) {
            message.annualIncome = exports.AnnualIncome.fromJSON(object.annualIncome);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.employmentStatus !== undefined &&
            message.employmentStatus !== EmploymentStatus.INVALID_EMPLOYMENT_STATUS) {
            obj.employmentStatus = employmentStatusToJSON(message.employmentStatus);
        }
        if (message.annualIncome !== undefined) {
            obj.annualIncome = exports.AnnualIncome.toJSON(message.annualIncome);
        }
        return obj;
    },
    create(base) {
        return exports.BorrowerInfo.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseBorrowerInfo();
        message.employmentStatus = object.employmentStatus ??
            EmploymentStatus.INVALID_EMPLOYMENT_STATUS;
        message.annualIncome = (object.annualIncome !== undefined && object.annualIncome !== null)
            ? exports.AnnualIncome.fromPartial(object.annualIncome)
            : undefined;
        return message;
    },
};
function createBaseAnnualIncome() {
    return { exact: undefined, range: undefined };
}
exports.AnnualIncome = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.exact)) {
            message.exact = amount_1.Amount.fromJSON(object.exact);
        }
        if (isSet(object.range)) {
            message.range = exports.AnnualIncomeAmountRange.fromJSON(object.range);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.exact !== undefined) {
            obj.exact = amount_1.Amount.toJSON(message.exact);
        }
        if (message.range !== undefined) {
            obj.range = exports.AnnualIncomeAmountRange.toJSON(message.range);
        }
        return obj;
    },
    create(base) {
        return exports.AnnualIncome.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAnnualIncome();
        message.exact = (object.exact !== undefined && object.exact !== null)
            ? amount_1.Amount.fromPartial(object.exact)
            : undefined;
        message.range = (object.range !== undefined && object.range !== null)
            ? exports.AnnualIncomeAmountRange.fromPartial(object.range)
            : undefined;
        return message;
    },
};
function createBaseAnnualIncomeAmountRange() {
    return { min: amount_1.Amount.fromPartial({}), max: undefined };
}
exports.AnnualIncomeAmountRange = {
    fromJSON(object) {
        const message = {
            min: isSet(object.min) ? amount_1.Amount.fromJSON(object.min) : amount_1.Amount.fromPartial({}),
        };
        if (isSet(object.max)) {
            message.max = amount_1.Amount.fromJSON(object.max);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.min !== undefined) {
            obj.min = amount_1.Amount.toJSON(message.min);
        }
        if (message.max !== undefined) {
            obj.max = amount_1.Amount.toJSON(message.max);
        }
        return obj;
    },
    create(base) {
        return exports.AnnualIncomeAmountRange.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAnnualIncomeAmountRange();
        message.min = (object.min !== undefined && object.min !== null)
            ? amount_1.Amount.fromPartial(object.min)
            : amount_1.Amount.fromPartial({});
        message.max = (object.max !== undefined && object.max !== null)
            ? amount_1.Amount.fromPartial(object.max)
            : undefined;
        return message;
    },
};
function applicationStatusFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_APPLICATION_STATUS':
            return ApplicationStatus.INVALID_APPLICATION_STATUS;
        case 1:
        case 'APPLIED':
            return ApplicationStatus.APPLIED;
        case 2:
        case 'PENDING_DATA':
            return ApplicationStatus.PENDING_DATA;
        case 3:
        case 'APPROVED':
            return ApplicationStatus.APPROVED;
        case 4:
        case 'DECLINED':
            return ApplicationStatus.DECLINED;
        case 5:
        case 'WITHDRAWN':
            return ApplicationStatus.WITHDRAWN;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return ApplicationStatus.UNRECOGNIZED;
    }
}
exports.applicationStatusFromJSON = applicationStatusFromJSON;
function applicationStatusToJSON(object) {
    switch (object) {
        case ApplicationStatus.INVALID_APPLICATION_STATUS:
            return 'INVALID_APPLICATION_STATUS';
        case ApplicationStatus.APPLIED:
            return 'APPLIED';
        case ApplicationStatus.PENDING_DATA:
            return 'PENDING_DATA';
        case ApplicationStatus.APPROVED:
            return 'APPROVED';
        case ApplicationStatus.DECLINED:
            return 'DECLINED';
        case ApplicationStatus.WITHDRAWN:
            return 'WITHDRAWN';
        case ApplicationStatus.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.applicationStatusToJSON = applicationStatusToJSON;
function statusReasonFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_STATUS_REASON':
            return StatusReason.INVALID_STATUS_REASON;
        case 1:
        case 'WITHDRAWN_EXPIRED':
            return StatusReason.WITHDRAWN_EXPIRED;
        case 2:
        case 'PENDING_CREDIT_UNFREEZE':
            return StatusReason.PENDING_CREDIT_UNFREEZE;
        case 3:
        case 'HIGH_RISK_USER':
            return StatusReason.HIGH_RISK_USER;
        case 4:
        case 'CREDIT_REPORT_DECEASED':
            return StatusReason.CREDIT_REPORT_DECEASED;
        case 5:
        case 'FRAUD_ALERT':
            return StatusReason.FRAUD_ALERT;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return StatusReason.UNRECOGNIZED;
    }
}
exports.statusReasonFromJSON = statusReasonFromJSON;
function statusReasonToJSON(object) {
    switch (object) {
        case StatusReason.INVALID_STATUS_REASON:
            return 'INVALID_STATUS_REASON';
        case StatusReason.WITHDRAWN_EXPIRED:
            return 'WITHDRAWN_EXPIRED';
        case StatusReason.PENDING_CREDIT_UNFREEZE:
            return 'PENDING_CREDIT_UNFREEZE';
        case StatusReason.HIGH_RISK_USER:
            return 'HIGH_RISK_USER';
        case StatusReason.CREDIT_REPORT_DECEASED:
            return 'CREDIT_REPORT_DECEASED';
        case StatusReason.FRAUD_ALERT:
            return 'FRAUD_ALERT';
        case StatusReason.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.statusReasonToJSON = statusReasonToJSON;
function employmentStatusFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_EMPLOYMENT_STATUS':
            return EmploymentStatus.INVALID_EMPLOYMENT_STATUS;
        case 2:
        case 'UNEMPLOYED':
            return EmploymentStatus.UNEMPLOYED;
        case 3:
        case 'EMPLOYED':
            return EmploymentStatus.EMPLOYED;
        case 4:
        case 'RETIRED':
            return EmploymentStatus.RETIRED;
        case 5:
        case 'STUDENT':
            return EmploymentStatus.STUDENT;
        case 6:
        case 'SELF_EMPLOYED':
            return EmploymentStatus.SELF_EMPLOYED;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return EmploymentStatus.UNRECOGNIZED;
    }
}
exports.employmentStatusFromJSON = employmentStatusFromJSON;
function employmentStatusToJSON(object) {
    switch (object) {
        case EmploymentStatus.INVALID_EMPLOYMENT_STATUS:
            return 'INVALID_EMPLOYMENT_STATUS';
        case EmploymentStatus.UNEMPLOYED:
            return 'UNEMPLOYED';
        case EmploymentStatus.EMPLOYED:
            return 'EMPLOYED';
        case EmploymentStatus.RETIRED:
            return 'RETIRED';
        case EmploymentStatus.STUDENT:
            return 'STUDENT';
        case EmploymentStatus.SELF_EMPLOYED:
            return 'SELF_EMPLOYED';
        case EmploymentStatus.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.employmentStatusToJSON = employmentStatusToJSON;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=application.js.map